import { render, staticRenderFns } from "./RootTipiFabbricatoView.vue?vue&type=template&id=29159a8a&"
import script from "./RootTipiFabbricatoView.vue?vue&type=script&lang=ts&"
export * from "./RootTipiFabbricatoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports